import React from "react";

const HMCTwitter = () => {
  return (
    <svg
      width="60"
      height="61"
      viewBox="0 0 60 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_441_7242)">
        <path
          d="M47.8591 21.5623C47.8873 21.9561 47.8873 22.3529 47.8873 22.7498C47.8873 34.8936 38.6194 48.8967 21.6721 48.8967C16.6637 48.9 11.7602 47.4647 7.54785 44.7623C8.27571 44.8493 9.008 44.8942 9.74106 44.8967C13.8909 44.9004 17.9212 43.5112 21.1834 40.9529C19.2605 40.9169 17.3969 40.2825 15.8532 39.1384C14.3095 37.9943 13.1628 36.3976 12.5734 34.5717C13.9541 34.8375 15.3775 34.784 16.7343 34.4154C14.65 33.9958 12.7754 32.87 11.4283 31.2291C10.0812 29.5882 9.34448 27.5331 9.34315 25.4123V25.2967C10.6248 26.0089 12.0594 26.4033 13.5259 26.4467C11.5746 25.1476 10.1931 23.1555 9.66277 20.8761C9.13246 18.5967 9.49324 16.2014 10.6716 14.1779C12.9847 17.0174 15.8708 19.3398 19.1425 20.9943C22.4141 22.6487 25.9981 23.5982 29.6617 23.7811C29.2019 21.8119 29.4056 19.7465 30.2411 17.9044C31.0767 16.0622 32.4976 14.5461 34.284 13.5904C36.0704 12.6348 38.1228 12.2929 40.1236 12.6178C42.1245 12.9426 43.9622 13.916 45.3526 15.3873C47.4182 14.9865 49.3997 14.2361 51.2116 13.1686C50.524 15.2973 49.0842 17.1042 47.1604 18.2529C48.9871 18.0377 50.7709 17.55 52.4523 16.8061C51.2173 18.6516 49.6618 20.2623 47.8591 21.5623Z"
          fill="url(#paint0_radial_441_7242)"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_441_7242"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(71.0221 86.5994) rotate(-130.068) scale(124.018 329.524)"
        >
          <stop stopColor="#00B0CA" />
          <stop offset="1" stopColor="#9C2AA0" />
        </radialGradient>
        <clipPath id="clip0_441_7242">
          <rect
            width="60"
            height="60"
            fill="white"
            transform="translate(0 0.699951)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HMCTwitter;
